import * as React from 'react';
import {Switch, Route} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {setBodyId} from '../../../dom';

import {mountFormFlashBanner} from '../../forms/form-flash-banner/mount-form-flash-banner';

import {mountSettingsSidebar} from '../mount-settings-sidebar';
import {SetupPage} from '../setup-page';
import type {ServerTitleBarProps} from '../setup-root';

import {mountDromoProductImporter} from './dromo/products/mount-dromo-product-importer';
import {mountDromoQuotaImporter} from './dromo/quota/mount-dromo-quota-importer';
import {Import2StatusPage} from './import2/import2-status-page';
import {mountImportFromCRMList} from './import2/mount-import-from-crm-list';
import {mountImportUnsubscribes} from './mount-import-unsubscribes';
import {mountWhiteGloveForm} from './mount-white-glove-form';
import {mountWhiteGloveThankYou} from './mount-white-glove-thank-you';

type OwnProps = {
    onServerTitleBarChange: (titleBarProps: ServerTitleBarProps) => void;
};

type Props = OwnProps & ContextRouter;

export function ImportRoot(props: Props) {
    React.useEffect(() => {
        setBodyClasses(props.location.pathname);
    }, [props.location.pathname]);

    return (
        <Switch>
            <Route
                path='/setup/import/white-glove'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            onServerTitleBarChange={props.onServerTitleBarChange}
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={mountWhiteGloveForm}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import/white-glove-thank-you'
                exact={true}
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            onServerTitleBarChange={props.onServerTitleBarChange}
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={mountWhiteGloveThankYou}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import/crm'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            onServerTitleBarChange={props.onServerTitleBarChange}
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={mountImportFromCRMList}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import/products'
                exact={true}
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            onServerTitleBarChange={props.onServerTitleBarChange}
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={() => {
                                mountDromoProductImporter();
                                mountSettingsSidebar();
                            }}
                            backgroundOffWhite={true}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import/quotas'
                exact={true}
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            onServerTitleBarChange={props.onServerTitleBarChange}
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={() => {
                                mountDromoQuotaImporter();
                                mountSettingsSidebar();
                            }}
                            backgroundOffWhite={true}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            onServerTitleBarChange={props.onServerTitleBarChange}
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={mountFormFlashBanner}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import-account-contact-csv/:importStage'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    if (routeProps.match.params.importStage === 'match') {
                        setBodyId('import-map');
                    } else if (routeProps.match.params.importStage === 'preview') {
                        setBodyId('import-preview');
                    }

                    return (
                        <SetupPage
                            pageTitle='Import'
                            onServerTitleBarChange={props.onServerTitleBarChange}
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                            onViewRendered={mountImportUnsubscribes}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import-highrise'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import-salesforcezip/:importStage'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    if (routeProps.match.params.importStage === 'configure') {
                        setBodyId('import-configure');
                    } else {
                        setBodyId('');
                    }

                    return (
                        <SetupPage
                            pageTitle='Import'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import-office365-contacts'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import-vcard'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import-quickbooks'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import-google-contacts'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return (
                        <SetupPage
                            pageTitle='Import'
                            viewUrl={routeProps.location.pathname}
                            viewParams={routeProps.location.search}
                        />
                    );
                }}
            />
            <Route
                path='/setup/import-import2/status/:originId'
                render={(routeProps) => {
                    setBodyClasses(routeProps.location.pathname);
                    setBodyId('');

                    return <Import2StatusPage originId={routeProps.match.params.originId} />;
                }}
            />
        </Switch>
    );
}

const baseBodyClasses = ['manage', 'page', 'settings'];

function setBodyClasses(pathname: string): void {
    const body = document.querySelector('body');

    if (!body) return;

    if (pathname.includes('/setup/import')) {
        body.className = baseBodyClasses.concat('import').join(' ');
    }
}
